import noop from "lodash/noop";
import PropTypes from "prop-types";
import ty from "typy";

import { Button } from "@flexisaf/flexibull2/build/button";
import { IconBack, IconNext } from "@/components/icons";
import { theme } from "@/style";

import { useStepper } from "./Stepper";
import { StepButton, StepButtonsWrapper } from "./stepperStyles";

export default function StepButtons(props) {
    const { onNext, onPrev, onSubmit, isSubmitting } = props;
    const stepper = useStepper();

    const handlePrevClick = () => {
        if (ty(onPrev).isFunction) {
            onPrev();
            return;
        }
        stepper.handlePrev();
    };

    const handleNextClick = () => {
        if (ty(onNext).isFunction) {
            onNext();
            return;
        }
        stepper.handleNext();
    };

    const handleSubmitClick = () => {
        if (isSubmitting) return;
        if (ty(onSubmit).isFunction) onSubmit();
    };

    return (
        <StepButtonsWrapper>
            <StepButton prev onClick={handlePrevClick} disabled={stepper.view === 0}>
                <IconBack style={{ marginRight: "1em" }} /> Previous
            </StepButton>
            {stepper.view >= stepper.totalSteps - 1 ? (
                <Button
                    progress={isSubmitting}
                    onClick={handleSubmitClick}
                    style={{
                        background: theme.PrimaryColor,
                        color: "white",
                        height: "4em",
                        padding: "1.2em 2em",
                    }}
                >
                    {isSubmitting ? "Submitting..." : "Submit"}
                </Button>
            ) : (
                <StepButton next onClick={handleNextClick}>
                    <span style={{ marginRight: "1em" }}>Next</span> <IconNext />
                </StepButton>
            )}
        </StepButtonsWrapper>
    );
}

StepButtons.propTypes = {
    onPrev: PropTypes.func,
    onNext: PropTypes.func,
    onSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
};
